export enum CalendarListOrder {
    OldestFirst = "oldest-first",
    NewestFirst = "newest-first"
}
